import { RouteObject } from 'react-router-dom';

import { ROUTES } from '@routes/routes.constants';

export const myInformationRoutes = [
  {
    path: ROUTES.MY_INFORMATION,
    lazy: async () => ({
      Component: (await import('./MyInformationPage')).MyInformationPage,
    }),
  },
  {
    path: ROUTES.CHANGE_PASSWORD,
    lazy: async () => ({
      Component: (await import('./ChangePasswordPage')).ChangePasswordPage,
    }),
  },
  {
    path: ROUTES.MARKETING_PERMISSION,
    lazy: async () => ({
      Component: (await import('@views/MarketingPermissionPage'))
        .MarketingPermissionPage,
    }),
  },
] satisfies RouteObject[];
